import { render, staticRenderFns } from "./InputAvatar.vue?vue&type=template&id=4dc5370b&"
import script from "./InputAvatar.vue?vue&type=script&lang=js&"
export * from "./InputAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports